import { makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import useWindowSize from "../../../../../../helper/hooks/useWindowSize";
import UtilService from "../../../../../../helper/service";
import roles from "../../../../../../helper/roles";
import clsx from "clsx";
import apiConfigs from "../../../../../../config/config";

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    alignItems: 'center',
    width: '100%',
    paddingTop: 30,
  },
  topDescription: {
    marginTop: 65,
    fontSize: 20,
    fontFamily: 'roboto-light',
    color: '#606B76',
    lineHeight: 1.5,
    textAlign: 'center',
  },
  bottomDescription: {
    marginTop: 0,
    maxWidth: 900
  },
  img: {
    margin: '50px 0',
    width: 350
  },
  linkDescription: {
    cursor: 'pointer',
    color: '#017AEF',
    textDecoration: 'none'
  }
}));

function NoParticipants(props: any) {
  const classes = useStyles();
  const history = useHistory();
  const { title, description, link, img, nonCompleted, excluded } = props;
  const { currentSession, attendedIdentifiers } = useSelector((state: any) => state.analysis);
  const { session_type } = currentSession;

  const { filter } = useSelector((state: any) => state.creatorExperienceManager);

  const { width } = useWindowSize();
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : ""
  const attendedIds = session_type === 'MODERATED' ? attendedIdentifiers : attendedIdentifiers;

  const goParticipantTab = () => {
    let url = `/creator/experience-manager/participants/${currentSession['session_code']}`;
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['experiences'])) {
      url = `/subscriber/creator/experience-manager/participants/${currentSession['session_code']}`;
    }
    history.push(url);
  };

  const goDashboard = () => {
    let url = `/creator/dashboard`;
    if (UtilService.checkTrialAccess(loginUserData, roles['trial']['dashboard'])) {
      url = `/subscriber/creator/dashboard`;
    }
    history.push(url);
  };

  const isLeft = attendedIds.length > 0 && (currentSession['session_status'] === 'COMPLETED' || currentSession['session_type'] === 'ASYNC' || (currentSession['session_status'] === 'LIVE' && currentSession['session_type'] === 'MODERATED')) && filter

  return (
    <div className={classes.root} style={{ marginLeft: isLeft ? -230 : 0 }}>
      <p className={classes.topDescription}>
        {title}
      </p>
      <img
        src={nonCompleted ? '/assets/icons/liveanalysis/QA_engineers.svg' : (img ? img : '/assets/icons/liveanalysis/QA_switches.svg')}
        alt={'No Participants'}
        className={classes.img}
        style={{ width: (width ? width : 1600) / 4, minWidth: 300 }}
      />
      <span className={clsx(classes.topDescription, classes.bottomDescription)}>
        {description}
        {nonCompleted && <>
          To measure again, please create a new Experience from your <span className={classes.linkDescription} onClick={goDashboard}>Experience Dashboard</span>.
          <br /> If you need help finding participants, <a className={classes.linkDescription} href='mailto:support@getimmersion.com'>drop us a line</a>.
        </>}
      </span>
      {link && <div className={clsx(classes.topDescription, classes.bottomDescription)}>
        <span>
          In the meantime,
        </span>&nbsp;
        <span className={classes.linkDescription} onClick={goParticipantTab}>
          track your participants’ progress or invite more.
        </span>
      </div>}

      {
        excluded && <div className={clsx(classes.topDescription, classes.bottomDescription)} style={{ maxWidth: 790 }}>
          <span>
            We automatically remove bad data from experiences. You can always re-add removed participants at your own discretion by clicking on their device ID code in the left panel.
          </span>&nbsp;
          <a 
            className={classes.linkDescription} 
            href={apiConfigs.INTERCOM_DATA_CLEAN_URL} 
            target='_blank'
            rel="noreferrer"
          >
            Click here to find out more about the importance of cleaning data.
          </a>
        </div>
      }
    </div>
  )
}

export default NoParticipants;